import templateUrl from './metadata.html';

function metadata() {
  return {
    scope: {
      item: '='
    },
    templateUrl: templateUrl
  };
}

export default metadata;



/** WEBPACK FOOTER **
 ** ./src/app/ui/metadata.directive.js
 **/